import { useState } from 'react';
import { X, Save } from 'lucide-react';

export default function DraftEditor({ draft, onSave, onCancel }) {
  const [editedDraft, setEditedDraft] = useState(draft.ai_draft || '');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-semibold text-gray-900">Edit Draft</h2>
          <button
            onClick={onCancel}
            className="p-2 hover:bg-gray-100 rounded-md transition-colors"
          >
            <X size={20} className="text-gray-600" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {/* Original Reply */}
          <div className="mb-6">
            <h3 className="text-sm font-medium text-gray-700 mb-2">Original Reply:</h3>
            <div className="bg-gray-50 rounded p-4 text-sm text-gray-700 whitespace-pre-wrap">
              {draft.original_reply_text || draft.original_reply || 'No reply content'}
            </div>
          </div>

          {/* Editor */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Draft (editable):
            </label>
            <textarea
              value={editedDraft}
              onChange={(e) => setEditedDraft(e.target.value)}
              className="w-full h-64 p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent font-mono text-sm"
              placeholder="Edit the AI-generated draft..."
            />
            <p className="mt-2 text-xs text-gray-500">
              {editedDraft.length} characters
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(editedDraft)}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center gap-2 transition-colors"
          >
            <Save size={16} />
            Save & Send
          </button>
        </div>
      </div>
    </div>
  );
}


